export const LEVELS = [
    'Unspecifieid',
    'Basic',
    'Conversational',
    'Fluent',
    'Native/Bilingual'
];
